// extracted by css-extract-rspack-plugin
export default {"default":"default-baGPoY","disabled":"disabled-NwqrlO"};